import { Provider } from '@angular/core';
import { ExpensesFirestoreStore } from './expenses-firestore-store.service';
import { ExpensesMockStore } from './expenses-mock-store.service';
import { EXPENSES_STORE, resolveExpensesStoreMode } from './expenses-store.interface';

export function provideExpensesStore(): Provider[] {
  return [
    ExpensesMockStore,
    ExpensesFirestoreStore,
    {
      provide: EXPENSES_STORE,
      useFactory: (mock: ExpensesMockStore, firestore: ExpensesFirestoreStore) =>
        resolveExpensesStoreMode() === 'mock' ? mock : firestore,
      deps: [ExpensesMockStore, ExpensesFirestoreStore]
    }
  ];
}
